import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { QuizProvider } from './contexts/QuizContext';
import Welcome from './pages/Welcome';
import Quiz from './pages/Quiz';
import Loading from './pages/Loading';
import Offer from './pages/Offer';
import Logo from './components/Logo';

function App() {
  return (
    <QuizProvider>
      <Router>
        <div className="min-h-screen bg-white flex flex-col">
          <Logo />
          <Routes>
            <Route path="/" element={<Welcome />} />
            <Route path="/quiz" element={<Quiz />} />
            <Route path="/loading" element={<Loading />} />
            <Route path="/offer" element={<Offer />} />
          </Routes>
        </div>
      </Router>
    </QuizProvider>
  );
}

export default App;
